import axios, { CancelToken } from 'axios';
import { CellTowerDto, DeviceLastReportDto } from '@/features/map/types/devicesLastReport.types';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';
interface IMapService {
	getMapDevices(cancelToken?: CancelToken): Promise<DeviceLastReportDto[]>;
	getCellTower(): Promise<ServiceResponse<CellTowerDto[]>>;
	postGeolocation(cellTowers: CellTowerDto[]): Promise<ServiceResponse<CellTowerDto[]>>;
	getNearestDevices(latitude: number, longitude: number): Promise<ServiceResponse<DeviceLastReportDto[]>>;
}

class Service implements IMapService {
	async getMapDevices(cancelToken?: CancelToken): Promise<DeviceLastReportDto[]> {
		const response = await axios.get<DeviceLastReportDto[]>('/v2/devices/map', { cancelToken });
		return response.data || [];
	}

	async getCellTower(): Promise<ServiceResponse<CellTowerDto[]>> {
		const { data } = await axios.get<ServiceResponse<CellTowerDto[]>>('/v2/cell-tower-triangulations');
		return data;
	}

	async postGeolocation(cellTowers: CellTowerDto[]): Promise<ServiceResponse<CellTowerDto[]>> {
		const { data } = await axios.post<ServiceResponse<CellTowerDto[]>>(
			'/v2/cell-tower-triangulations/geolocation',
			{
				cellTowers,
			}
		);
		return data;
	}

	async getNearestDevices(latitude: number, longitude: number): Promise<ServiceResponse<DeviceLastReportDto[]>> {
		const { data } = await axios.get<ServiceResponse<DeviceLastReportDto[]>>(
			`/v2/trackingHistory/nearest-devices/${latitude}/${longitude}`
		);
		return data;
	}
}

const MapService: IMapService = new Service();

export default MapService;
